module.exports = __webpack_public_path__ + "img/home.b721e33c.svg";